import React from 'react';

export const ErrorText: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className="text-secondary-300 font-dmsans text-[11px] py-[5px]">
      {' '}
      {text}
    </div>
  );
};
